module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diane Zahler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Diane Zahler ")]), _vm._v("is the author of "), _c('I', [_vm._v("Baker’s Magic")]), _vm._v(", as well as several middle-grade fairy tale reimaginings: "), _c('I', [_vm._v("Sleeping Beauty’s Daughters, Princess of the Wild Swans, A True Princess")]), _vm._v(", and"), _c('I', [_vm._v("The Thirteenth Princess")]), _vm._v(". She lives in Wassaic, New York. Visit dianezahler.com.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GUspYR/tc-custom/9781629799186_cover.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marvelwood Magicians\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Eleven-year-old Mattie Marvelwood comes from a family of traveling performers. Her dad is an illusionist; her mom is a fortune-teller; her brother has a vanishing act; and she herself is a mind-reader. But the Marvelwoods have a deep secret. The acts they perform at carnivals, fairs, and circuses are not just acts. Their powers are real. In all their wanderings, the Marvelwoods have never met another performer with gifts like theirs—until they join Master Morogh’s Circus of Wonders! But it turns out that Master Morogh’s true talent is stealing the gifts of others. When he steals Mattie’s brother’s vanishing ability, the family has a big decision to make. Do they run, leaving Bell’s gift behind to save the rest of them, or risk exposure by trying to beat the duplicitous ringmaster at his own game?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Boyds Mills Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1291cb2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0